/******/ (() => {
  // webpackBootstrap
  var __webpack_exports__ = {};
  window.PXUTheme.jsFeaturedCollection = {
    init: function ($section) {
      // Add settings from schema to current object
      window.PXUTheme.jsFeaturedCollection = $.extend(
        this,
        window.PXUTheme.getSectionData($section)
      );

      // Initialize desktop slider
      if (this.collection_layout === "slider") {
        this.addClassToSlider($section, "desktop");
        this.createSlider(".slider-gallery--desktop");
      }

      // Initialize mobile slider
      if (this.collection_layout_mobile === "slider") {
        this.addClassToSlider($section, "mobile");
        this.createSlider(".slider-gallery--mobile");
      }
    },

    addClassToSlider: function ($section, type) {
      if (type === "desktop") {
        // Ensure the desktop slider class is added
        if (!$section.find(".slider-gallery--desktop").length) {
          $section.find(".slider-gallery").addClass("slider-gallery--desktop");
        }
      } else if (type === "mobile") {
        // Ensure the mobile slider class is added
        if (!$section.find(".slider-gallery--mobile").length) {
          $section.find(".slider-gallery").addClass("slider-gallery--mobile");
        }
      }
    },

    createSlider: function (el) {
      const slider = $(el);

      if (slider.length) {
        $(slider).flickity({
          lazyLoad: 2,
          freeScroll: true,
          imagesLoaded: true,
          draggable: true,
          cellAlign: "center",
          wrapAround: true,
          pageDots: false,
          contain: true,
          prevNextButtons:
            this.products_limit > this.products_per ? true : false,
          initialIndex: 0,
          arrowShape: arrowShape,
        });

        // Resize Flickity slider on settle
        $(slider).on("settle.flickity", () => $(slider).flickity("resize"));
      }
    },

    unload: function ($section) {
      let $slider = $section.find(".flickity-enabled");
      if ($slider.length) {
        $slider.flickity("destroy");
      }
    },
  };

  /******/
})();
